export default "__VITE_ASSET__BVhYtCPA__"